import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
	selector: 'app-input',
	template: `
<div>
<ng-template *ngIf="field.name === 'id'; else show">
<mat-form-field class="full-width-field"  [formGroup]="group" name="id_number" id="id_number" style="display: none;">
<input matInput [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType" >
<ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
<mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
</ng-container>
</mat-form-field>
</ng-template>

<ng-template #show>
<mat-form-field class="full-width-field"  [formGroup]="group" name="id_number" id="id_number" >
<input matInput [formControlName]="field.name" [placeholder]="field.label" [type]="field.inputType" >
<ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
<mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
</ng-container>
</mat-form-field>
</ng-template>


</div>
`,
	styles: []
})
export class InputComponent implements OnInit {
	field: FieldConfig;
	group: FormGroup;
	constructor() {}
	ngOnInit() {}
}
